<template>
	<div class="memo-info-box">
		<div class="fx-title" style="margin-top:25px">
			<p>附属信息</p>
		</div>
		<div class="info-box">
			<div>
				<span class="info-title">下单时间：</span>
				<div>
					<el-date-picker
						value-format='yyyy-MM-dd HH:mm:ss'
						size="mini"
						:picker-options="pickOptions"
						v-model="createOrderDate"
						type="datetime"
						placeholder="选择日期时间">
					</el-date-picker>
				</div>
			</div>
			<div><span class="info-title">期望到货时间：</span>
				<div>
					<el-date-picker
						value-format='yyyy-MM-dd HH:mm:ss'
						size="mini"
						v-model="wantarrivaldate"
						type="datetime"
						placeholder="选择日期时间">
					</el-date-picker>
				</div>
			</div>
			<div><span class="info-title">备货时间：</span>
				<div>
					<el-date-picker
						value-format='yyyy-MM-dd HH:mm:ss'
						size="mini"
						v-model="preparedate"
						type="datetime"
						placeholder="选择日期时间">
					</el-date-picker>
				</div>
			</div>
			<!-- <div><span class="info-title">付款提醒：</span>
				<div>
					<el-checkbox v-model="isOffLine" style="margin-top:3px;">无需通知买家，直接发货</el-checkbox>
				</div>
			</div> -->
			<div class="total-memo"><span class="info-title">上传图片：</span>
				<div class="img-container">
					<ImgUpload
						class="show-img"
						v-for="(item, index) in showSrc"
						:key="index"
						:imgSrc.sync="item.imgurl"
						:imgId.sync="item.id"
						:location="index"
						:uploadError.sync="item.uploadError"
						@deletImg="deletImg"
						@uploadNewImg="uploadNewImg"
						ref="showUpload"
					/>
					<ImgUpload2
						class="show-img"
						v-if="showSrc.length < 3"
						:acountValue='acountValue'
						@uploadNewImg="uploadNewImg"
						ref="showUpload2"
					/>
					<div class="img-tip">支持的图片格式：jpg、jpeg、png，图片大小1M以内，最多上传3张</div>
				</div>
			</div>
			<div class="total-memo"><span class="info-title">整单备注：</span>
				<el-input
					type="textarea"
					placeholder="最大200字"
					maxlength="200"
					resize="none"
					rows="3"
					v-model="textarea"
					:disabled="!acountValue"
					class="info-textarea">
				</el-input>
			</div>
		</div>
	</div>
</template>

<script>
import ImgUpload from '@/components/batchValetDetail/ImgUpload.vue'
import ImgUpload2 from '@/components/batchValetDetail/ImgUpload2.vue'
export default {
	name: 'memoInfo',
	components: {
		ImgUpload, ImgUpload2
	},
	props: {
		acountValue: {
			type: String
		}
		// active: {
		// 	type: String
		// },
		// clearing: {
		// 	type: String,
		// 	default: '0'
		// },
		// clddock: {
		// 	type: Number,
		// 	default: 0
		// }
	},
	data () {
		return {
			createOrderDate: '',
			wantarrivaldate: '',
			preparedate: '',
			// radio: '0',
			textarea: '',
			showSrc: [],
			pickOptions: {
				disabledDate: (time) => {
					return time.getTime() > Date.now()
				}
			}
		}
	},
	watch: {
		acountValue (val) {
			if (!val) {
				this.showSrc = []
			}
		}
	},
	created () {
	},
	methods: {
		uploadNewImg (oldUrl, index) {
			let needUrl = `${this.$fxBaseApi.urlQIVShop}/replacorder/upload`
			var formData = new FormData()
			if (oldUrl === '') {
				formData.append('extension', this.$refs.showUpload2.fileFiles.name.split('.')[1])
				formData.append('file', this.$refs.showUpload2.fileFiles)
			} else {
				formData.append('extension', this.$refs.showUpload[index].fileFiles.name.split('.')[1])
				formData.append('file', this.$refs.showUpload[index].fileFiles)
			}
			formData.append('oldUrl', oldUrl)
			this.$store.dispatch('requestFilePost', {
				url: needUrl,
				data: formData
			}).then(res => {
				if (res.result) {
					this.$message.success('上传图片成功')
					let img = { imgurl: res.data, id: this.showSrc.length + '', uploadError: false }
					if (oldUrl === '') {
						this.showSrc.push(img)
					} else {
						this.showSrc.splice(index, 1, img)
					}
				} else {
					this.$message.error(res.msg)
				}
			}).catch((error) => {
				this.$message.error(error.msg)
			})
		},
		deletImg (index, path) {
			index = +index
			let params = {
				deletePath: path
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/replacorder/remove`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('删除成功')
					this.showSrc.splice(index, 1)
				} else {
					this.$message.error(res.msg)
				}
			}).catch((error) => {
				this.$message.error(error.msg)
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.memo-info-box {
	padding-left: 10px
	font-size: 14px
	margin-top: 10px
	text-align: left
	padding-bottom: 20px
	.fx-title {
		font-weight: 700
		margin: 10px 0 10px 0
	}
	.info-box {
		text-align: left
		&>div {
			display: flex
			align-items: center
			padding-left: 14px
			margin-top: 20px
			&.total-memo {
				align-items: flex-start
			}
		}
		.info-title {
			text-align :right;
			width :100px;
			margin-right: 10px
		}
		.info-textarea {
			width: 350px
		}
	}
	.img-tip {
		clear: both;
		color: #999
	}
}
</style>
